const findInTree = (tree, { id = "", index = "value", dep = "list" }) => {
	if (!tree?.length) {
		return null;
	}

	for (const branch of tree) {
		if (String(branch[index]) === String(id)) {
			return branch;
		}
		if (branch[dep]?.length) {
			const found = findInTree(branch[dep], { id, index, dep });
			if (found) {
				return found;
			}
		}
	}

	return null;
};

const findInParentInTree = (tree, args) => {
	const { id = "", index = "value", dep = "list" } = args || {};

	if (!tree?.length || !id) {
		return null;
	}

	for (const branch of tree) {
		if (String(branch[index]) === String(id)) {
			return branch;
		}

		if (branch?.[dep]?.length) {
			const found = findInTree(branch[dep], { id, index, dep });
			if (found) {
				return branch;
			}
		}
	}

	return null;
};

const isInTree = (tree = [], index = "value", branch = undefined) => {
	if (!tree?.length || !index || !branch) {
		return false;
	}
	const { [index]: compare } = branch || {};
	return tree.some((item) => item?.[index] === compare);
};

const filterTree = (tree, { text, index = "value", dep = "list" }) => {
	const filtered = [];

	if (!tree?.length) {
		return tree;
	}

	tree.forEach((branch) => {
		let match = false;

		// Check if the current branch matches the text
		if (String(branch?.[index]).toLowerCase().includes(text?.toLowerCase())) {
			match = true;
		}

		// Recursively filter the children
		if (branch?.[dep]?.length) {
			const temp = filterTree(branch[dep], { text, index, dep });
			if (temp?.length) {
				match = true;
				const newBranch = { ...branch };
				newBranch[dep] = temp;
				filtered.push(newBranch);
			}
		}

		// If the current branch matches, add it to the filtered list
		if (match && !isInTree(filtered, index, branch)) {
			filtered.push(branch);
		}
	});

	return filtered;
};

const getFirstLeaf = (tree = [], dep = "list") => {
	if (!tree?.length) {
		return null;
	}
	let item = tree.at(0);
	while (item[dep] != null) {
		item = item[dep].at(0);
	}
	return item;
};

const getLastLeaf = (tree = [], dep = "list") => {
	let item = tree.at(tree.length - 1);
	while (item[dep] != null) {
		item = item[dep].at(item[dep].length - 1);
	}
	return item;
};

export { filterTree, findInParentInTree, findInTree, getFirstLeaf, getLastLeaf };
